
export enum ProjectType {
    DEBT = "DEBT", //залоговый займ (на будущее) такой же как лоан по виду
    LOAN = "LOAN", //факторинг
    PROJECT = "PROJECT", //проектный займ
    SOCIAL = "SOCIAL", //социальный
}
type ProjectTypeRecord = Record<ProjectType, string>;

export const ProjectMapped: ProjectTypeRecord = {
  [ProjectType.LOAN]: "Заем с обеспечением",
  [ProjectType.DEBT]: "Заем с обеспечением",
  [ProjectType.PROJECT]: "Проектный заем",
  [ProjectType.SOCIAL]: "Социальный проект",
};

export const translateProjectType = (type: ProjectType): string => {
  return ProjectMapped[type];
};